/**
 * @param {boolean} condition
 * @param {string} message
 */
export const invariant = (condition, message) => {
	if (process.env.NODE_ENV !== "production" && condition) {
		throw new Error(message);
	}
};
